import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MarketingContentService {

  constructor() { }

  getHero(marketingData: any): any {
    const data = marketingData?.details?.data?.homepage_hero;
    return data ? [data.fields] : null;
  }

  getCarouselHeader(marketingData: any): any {
    const data = marketingData?.details?.data?.carousel_header;
    return data ? data.map(item => item.fields) : null;
  }

  getPopularCategories(marketingData: any): any {
    const data = marketingData?.details?.data?.popular_categories;
    return data && data.length > 0 ? data[0].fields : null;
  }

  getPopularProducts(marketingData: any): any {
    const data = marketingData?.details?.data?.popular_products;
    return data ? data.map(item => item.fields) : null;
  }

  getFeaturedCollections(marketingData: any): any {
    const data = marketingData?.details?.data?.featured_collections;
    return data && data.length > 0 ? data[0].fields : null;
  }

  getTopBrands(marketingData: any): any {
    const data = marketingData?.details?.data?.top_brands;
    return data && data.length > 0 ? data[0].fields : null;
  }

  getSubcategories(marketingData: any): any {
    return null; // No subcategories in current data
  }

  getDesignToolProducts(marketingData: any): any {
    const data = marketingData?.details?.data?.design_tool_products;
    return data ? data.map(item => item.fields) : null;
  }

  getBanner(marketingData: any): any {
    const data = marketingData?.details?.data?.banner;
    return data ? data.map(item => item.fields) : null;
  }

  getCategoryGallery(marketingData: any): any {
    const data = marketingData?.details?.data?.category_gallery;
    return data ? data.map(item => item.fields) : null;
  }

  getKeyFeatures(marketingData: any): any {
    const data = marketingData?.details?.data?.key_features;
    return data ? data.map(item => item.fields) : null;
  }

  getCallToAction(marketingData: any): any {
    const data = marketingData?.details?.data?.call_to_action;
    return data ? data.map(item => item.fields) : null;
  }

  getFAQ(marketingData: any): any {
    const data = marketingData?.details?.data?.faq;
    return data ? data.map(item => item.fields) : null;
  }
}